import { createSvgIcon } from '@material-ui/core';

export const Remote2Icon = createSvgIcon(
  <svg viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.8 10C3.8 6.58 6.58 3.8 10 3.8H18V0H10C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20H18V16.2H10C6.58 16.2 3.8 13.42 3.8 10ZM12 12H28V8H12V12ZM30 0H22V3.8H30C33.42 3.8 36.2 6.58 36.2 10C36.2 13.42 33.42 16.2 30 16.2H22V20H30C35.52 20 40 15.52 40 10C40 4.48 35.52 0 30 0Z"
      fill="currentColor"
    />
  </svg>,
  'Remote2Icon',
);
